import Axios from 'axios';
import ENV from './env';

export default {

  /**
   * Get Newest Videos lists 60
   */
  getNewSlideVideoList() {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos?per_page=60`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        data,
      } = resultData;

      return {
        data,
        success,
        message,
        next_page,
      };

    })
    .catch(error => console.log(error));
    
  },

  /**
   * Get Views Videos
   */
  getVideoViewList(num) {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos?sorting=view&page=${num}`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        total_pages,
        data,
      } = resultData;

      return {
        data,
        success,
        message,
        next_page,
        total_pages,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get Views Videos lists 60
   */
  getViewSlideVideoList() {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos?per_page=60&sorting=view`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        data,
      } = resultData;

      return {
        data,
        success,
        message,
        next_page,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get Banner Videos lists
   */
  getBannerVideoList() {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos/slider`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        data,
      } = resultData;

      return {
        _data: data,
        _success: success,
        _message: message,
        _nextPage: next_page,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get Brand Master lists
   */
  getVideoList() {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        data,
      } = resultData;

      return {
        _data: data,
        _success: success,
        _message: message,
        _nextPage: next_page,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get More Brand Master lists
   */
  getMoreVideoList(num) {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos?page=${num}`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        next_page,
        total_pages,
        data,
      } = resultData;

      return {
        data,
        _success: success,
        _message: message,
        _nextPage: next_page,
        total_pages,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get brand Master Advertisers List
   */
  getAdvertisersList(advertiserId) {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/advertisers/${advertiserId}/videos`)
    .then((response) => {

      const resultData = response.data;

      const {
        data,
      } = resultData;

      return {
        _data: data,
      };

    })
    .catch(error => console.log(error));
  },

  /**
   * Get brand Master Advertisers Video
   */
  getAdvertisersVideo(advertiserId, id) {
    return Axios(`${ENV.ERP_PORT}/api/v1/bm/advertisers/${advertiserId}/videos/${id}`)
    .then((response) => {

      const resultData = response.data;

      const {
        data,
      } = resultData;

      return {
        _data: data,
      };

    })
    .catch(() => {

      // if 404
      const {
        origin,
      } = window.location;
      
      window.location = `${origin}/`;
      
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/video.js